import './submit-payment.scss';
import ButtonKMQ from "../../UI/Button/ButtonKMQ";
import {useMutateStripeSession} from "../../../api/payment/useMutateStripeSession";
import {useContext, useEffect, useState} from "react";
import {PortfolioContext} from "../../../hooks/Context/PortfolioContext";
import {useNavigate} from "react-router-dom";
import Loading from "../../UI/Loading/Loading";
import {UserContext} from "../../../hooks/Context/UserContext";
import {ButtonTypes} from "../../../constants/ui/types/ButtonTypes";
import {useQueryCourses} from "../../../api/admin/useQueryCourses";
import PlusIcon from '../../../assets/icons/UI/icons/plus-circled.svg';
import ApplicationModal from '../../UI/Modals/ApplicationModal/ApplicationModal';

const PortfolioStatusButtons = () => {
  const [user] = useContext(UserContext);
  const navigate = useNavigate();
  const [portfolio, setPortfolio] = useContext(PortfolioContext);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const {data: courses} = useQueryCourses({
    portfolio_id: portfolio.id,
    paid: 'cart',
    userIsSoft: user.isSoft
  });

  const handleSubmit = () => {
    navigate('/cpl-applicant/cart');
  }

  return <div className={'submit-payment-button'}>
    <ButtonKMQ onClick={handleSubmit} disabled={!(courses?.data?.courses?.length > 0)} type={ButtonTypes.Tertiary}>
      Go to cart
    </ButtonKMQ>
    <span className={'submit-payment-button-startover'} onClick={openModal}>
      <img
        src={PlusIcon}
        alt={'plus'}
        className={'submit-payment-button-startover-icon'}
      />
      Start new application
    </span>
    <ApplicationModal
        open={isModalOpen}
        onClose={closeModal}
      />
  </div>
}

export default PortfolioStatusButtons;